
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/payment-initiation-one-time/refunds",
      function () {
        return require("private-next-pages/docs/payment-initiation/payment-initiation-one-time/refunds.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/payment-initiation-one-time/refunds"])
      });
    }
  